(() => {
  const ROOT_SELECTOR = '[data-ff-cart-root]';
  const BUTTON_SELECTOR = '.ff-atc-button';
  function message(controls, text, isError = false) {
    if (!controls) return;
    let status = controls.querySelector('.ff-atc-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'ff-atc-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      controls.appendChild(status);
    }
    status.textContent = text || '';
    status.style.color = isError ? '#8b1e1e' : '';
  }
  async function addItem(root, button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const controls = button.closest('.ff-atc-controls');
    const select = controls && controls.querySelector('.ff-variant-select');
    const variantId = (select && select.value) || button.dataset.variantId;
    if (!variantId) { message(controls, 'Please choose an available option.', true); return; }
    const label = button.textContent.trim() || 'Add to cart';
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    button.textContent = 'Adding…';
    message(controls, '');
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    let sections = 'cart-icon-bubble';
    if (cartDrawer && cartDrawer.closest('.shopify-section')) {
      sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
    }
    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);
    try {
      const response = await fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');
      const cartBubble = document.getElementById('cart-icon-bubble');
      if (cartBubble && data.sections && data.sections['cart-icon-bubble']) cartBubble.innerHTML = data.sections['cart-icon-bubble'];
      if (cartDrawer) {
        if (data.sections) await cartDrawer.renderContents(data, false);
        if (typeof cartDrawer.refresh === 'function') await cartDrawer.refresh(true);
        cartDrawer.open(button);
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: button } }));
      }
      message(controls, 'Added to cart.');
      root.dispatchEvent(new CustomEvent('on:fresh-finds-cart:add', { bubbles: true, detail: { variantId } }));
    } catch (error) {
      message(controls, error && error.message ? error.message : 'This item could not be added.', true);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      button.textContent = label;
    }
  }
  function init(root) {
    if (!root || root.dataset.ffCartReady === 'true') return;
    root.dataset.ffCartReady = 'true';
    root.addEventListener('click', (event) => {
      const button = event.target.closest(BUTTON_SELECTOR);
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      addItem(root, button);
    });
  }
  function initAll(scope = document) { scope.querySelectorAll(ROOT_SELECTOR).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
